export const map =
  <T, U>(transformer: (value: T) => U) =>
  (array: T[]): U[] =>
    array.map(transformer)
